export type AppBillingInterval = 'MONTHLY' | 'ANNUAL';

export const FREE_PLAN_FEATURES = [
  '1 workspace',
  'Unlimited projects',
  '2 invited accounts',
  'Unlimited tasks',
] as const;

export const PRO_PLAN_FEATURES = [
  '4 workspaces',
  'Unlimited projects',
  '10 invited accounts',
  'Task migration between workspaces',
  'Unlimited tasks',
] as const;

export const PRO_PAGE_FEATURES = [
  ...PRO_PLAN_FEATURES,
  'Project-based hourly rates',
  'Billing status tracking',
  'Excel export',
  'Real-time updates',
] as const;

export function proChargeUsd(interval: AppBillingInterval): number {
  return interval === 'ANNUAL' ? 168 : 20;
}

export function billingIntervalLabel(interval: AppBillingInterval): 'Monthly' | 'Annual' {
  return interval === 'ANNUAL' ? 'Annual' : 'Monthly';
}

export function proPricePresentation(interval: AppBillingInterval): {
  amount: string;
  cadence: string;
  detail: string;
  modalPrice: string;
} {
  if (interval === 'ANNUAL') {
    return {
      amount: 'US$14',
      cadence: '/ month',
      detail: 'Billed US$168/year',
      modalPrice: 'US$14/month',
    };
  }

  return {
    amount: 'US$20',
    cadence: '/ month',
    detail: 'Billed every month',
    modalPrice: 'US$20/month',
  };
}
